import React, { useState } from "react";
import { createTrade, createTradeWithScreenshot } from "../services/api";

function normalizeDate(v) {
  if (!v) return "";
  if (v.includes("-")) return v;
  if (v.includes("/")) {
    const [m, d, y] = v.split("/");
    return `${y}-${m.padStart(2,"0")}-${d.padStart(2,"0")}`;
  }
  return v;
}

function today() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}

function AddTradeModal({ selectedDate, onClose, onSaved }) {
  const [form, setForm] = useState({
    date: selectedDate || today(),
    profit: "",
    mood: "",
    confluences: "",
    reason: "",
    improvements: "",
    notes: "",
    session: "",
    setup_type: "",
  });

  const [screenshot, setScreenshot] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const cleaned = { ...form, date: normalizeDate(form.date) };
      if (screenshot) {
        await createTradeWithScreenshot(cleaned, screenshot);
      } else {
        await createTrade(cleaned);
      }
      onSaved(cleaned.date);
    } catch (err) {
      setError(err.message || "Failed to save trade");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-top">
          <div>
            <h2>Add Trade</h2>
            <p className="muted-text">Log your trade, reflection, and screenshot.</p>
          </div>
          <button className="close-button" onClick={onClose}>Close</button>
        </div>

        {error && <div className="error-box">{error}</div>}

        <form className="trade-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Date</label>
              <input type="text" name="date" value={form.date} onChange={handleChange} placeholder="YYYY-MM-DD" required />
            </div>

            <div className="form-group">
              <label>Profit / Loss</label>
              <input type="number" step="0.01" name="profit" value={form.profit} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Mood</label>
              <input type="text" name="mood" value={form.mood} onChange={handleChange} placeholder="calm, anxious..." required />
            </div>

            <div className="form-group">
              <label>Session</label>
              <input type="text" name="session" value={form.session} onChange={handleChange} placeholder="London, NY..." />
            </div>

            <div className="form-group">
              <label>Setup Type</label>
              <input type="text" name="setup_type" value={form.setup_type} onChange={handleChange} placeholder="Breakout, pullback..." />
            </div>

            <div className="form-group">
              <label>Screenshot</label>
              <input type="file" accept=".png,.jpg,.jpeg,.webp" onChange={e => setScreenshot(e.target.files[0])} />
            </div>
          </div>

          <div className="form-group">
            <label>Confluences</label>
            <textarea name="confluences" value={form.confluences} onChange={handleChange} placeholder="What lined up for this trade?" required />
          </div>

          <div className="form-group">
            <label>Reason for Entry</label>
            <textarea name="reason" value={form.reason} onChange={handleChange} placeholder="Why did you take this trade?" required />
          </div>

          <div className="form-group">
            <label>Improvements</label>
            <textarea name="improvements" value={form.improvements} onChange={handleChange} placeholder="What could you have done better?" required />
          </div>

          <div className="form-group">
            <label>Notes</label>
            <textarea name="notes" value={form.notes} onChange={handleChange} placeholder="Any additional thoughts..." />
          </div>

          <div className="modal-actions">
            <button type="button" className="secondary-button" onClick={onClose}>Cancel</button>
            <button type="submit" className="primary-button" disabled={saving}>
              {saving ? "Saving..." : "Save Trade"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTradeModal;